import React, { useContext, useState } from 'react'
import { __ } from 'i18n-for-browser'
import '../../config/i18n'
import { SkycityContext } from '../../lib/SkycityProvider'

import { error } from '@react/react-spectrum/Toast'
import Button from '@react/react-spectrum/Button'

import FieldLabel from '@react/react-spectrum/FieldLabel'
import Textfield from '@react/react-spectrum/Textfield'

import axios from 'axios'

import { colligoSyncCall } from '../../lib/ccApi.js'
import {
    getFilename,
    getFilenameWithoutExt,
    getTempDirectory,
    getColligoHeaders
} from '../../lib/skycity.js'

import {
    exploreIndexDocument,
    exploreHomeDirectory,
    uploadFile,
    retrieveRendition,
    retrievePreSignedDownloadUrl
} from '../../lib/acpApi.js'
const LinkHeader = require('http-link-header')
const uuid = require('uuid/v4')

export default function Operation (files) {
    const {
        inputFiles,
        inputSecondFiles,
        seed_1,
        seed_2,
        seed_3,
        errorOptions,
        dispatch
    } = useContext(SkycityContext)

    // const [inputSeed_1, inputSeed_2, inputSeed_3] = useState(seeds)

    async function start (curFile, curSecondFile) {
        const codePayload = {
            inputImage: {
                fillArea: {
                    fillMask: {name: 'input_mask'}
                },
                source: {name: 'input_image'}
            },
            fastMode: true,
            seeds: [seed_1, seed_2, seed_3]
        }

        const formData = new FormData()
        // Download image to bytes
        const response = await fetch(curFile.path)
        const inputBlob = await response.blob()
        const responseMask = await fetch(curSecondFile.path)
        const inputBlobMask = await responseMask.blob()
        const inputObject = new File([inputBlob], 'input_image', { type: inputBlob.type })
        const maskObject = new File([inputBlobMask], 'input_mask', { type: inputBlobMask.type })
        formData.append('request', JSON.stringify(codePayload))
        formData.append('input_image', inputObject)
        formData.append('input_mask', maskObject)

        const config = {
            url: `${process.env.REACT_APP_CONFIG_ENDPOINT_MLCOLLIGO_CLIO_ERASE}/v1/images/clio-erase`,
            method: 'POST',
            mode: 'cors',
            timeout: 90000,
            headers: getColligoHeaders(),
            payload: codePayload,
            body: {
                formData: formData
            }
        }

        /* *********************************** */
        dispatch({ type: 'set-codes', payload: { config: config } })

        const { metadata, images } = await colligoSyncCall(config, "jpeg")
        console.log(`Received ${images.length} inpainted images`)

        // Process all images
        const processImagePromises = images.map(async (maskImage, index) => {
            // Create unique filename for each mask
            let outputFileName = `clioerase_${uuid()}_${curFile.shortName}_mask${index}.${maskImage.format}`

            const newFile = new File([maskImage.blob], outputFileName, { type: maskImage.contentType })

            // Upload file object to CC storage
            const outputHref = `${getTempDirectory()}/${outputFileName}`

            // 1. Explore the Index Document and get the Primary URL of the home Directory
            const homeDirectoryPrimaryUrl = await exploreIndexDocument()

            // 2. Explore the home Directory and get the Create URL of the Cloud Documents Directory
            const exploreHomeDirectoryResponse = await exploreHomeDirectory(
                homeDirectoryPrimaryUrl
            )
            const cloudDocumentsCreateUrl = exploreHomeDirectoryResponse.createLink
            const fileUploaded = await uploadFile(
                cloudDocumentsCreateUrl,
                newFile
            )
            const uploadlinks = LinkHeader.parse(fileUploaded.headers.get('link'))
            const primaryUrl = uploadlinks.refs.filter(val => val.rel.match('http://ns.adobe.com/adobecloud/rel/primary'))[0].uri
            const renditionUrl = uploadlinks.refs.filter(val => val.rel.match('http://ns.adobe.com/adobecloud/rel/rendition'))[0].uri
            const largeRendition = await retrieveRendition(
                renditionUrl,
                0,
                maskImage.contentType
            ) || URL.createObjectURL(maskImage.blob)
            const preSignedDownloadUrl = await retrievePreSignedDownloadUrl(primaryUrl)
            console.log('preSignedDownloadUrl', preSignedDownloadUrl)

            return {
                inputFile: curFile,
                secondInput: curSecondFile,
                name: getFilename(outputHref),
                shortName: getFilenameWithoutExt(outputHref),
                path: outputHref,
                outputThumbnail: largeRendition,
                output: largeRendition,
                outputToDownload: preSignedDownloadUrl,
                maskIndex: index,
                maskName: maskImage.name || `mask${index}`,
                maskFilename: maskImage.filename
            }
        })
        const processedImages = await Promise.all(processImagePromises)

        // Skycity library to be updated for response
        if (files.find(file => file.inputFile === curFile)) {
            return
        }

        // Add all processed images to files array
        files.push(...processedImages)

        dispatch({
            type: 'skycity-success',
            payload: {
                files: files,
                response: metadata,
                loading: false,
                wait: false
            }
        })
    }

    async function run (e) {
        try {
            dispatch({ type: 'skycity-run', payload: {} })

            files = []
            const funcArray = []
            inputFiles.forEach(curFile => {
                inputSecondFiles.forEach(inputSecondFile => {
                    funcArray.push(start(curFile, inputSecondFile))
                })
            })
            await axios.all(funcArray)
        } catch (e) {
            errorOccured(`${__('error_msg_title')}: ${e.stack}`)
        }
    }

    function isRunDisabled () {
        if (inputFiles && inputFiles.length > 0) {
            return false
        }
        return true
    }

    function errorOccured (errMsg, res) {
        console.log(errMsg)
        error(errMsg.slice(0, errorOptions.wordSlice), {
            onClose: () => console.log('close'),
            timeout: errorOptions.msgTimeout
        })
        dispatch({ type: 'error-occured', payload: { errMsg: errMsg, response: res, loading: false, wait: false } })
    }

    function setSeed (seed, index) {
        // props.inputSeeds.push(seed)
        console.log("SEEDS::::::::: ", 'set-seed-' + index)
        dispatch({ type: 'set-seed-' + index, payload: { seed: seed } })
    }

    try {
        return <div>
            <FieldLabel className="adobe-skycity-options-field" label="Seeds" position="left">
                <Textfield
                    // value={inputSeed_1}
                    defaultValue={333}
                    onChange={e => setSeed(parseInt(e), 1)}>
                </Textfield>
                <Textfield
                    // value={inputSeed_2}
                    defaultValue={334}
                    onChange={e => setSeed(parseInt(e), 2)}>
                </Textfield>
                <Textfield
                    // value={inputSeed_3}
                    defaultValue={335}
                    onChange={e => setSeed(parseInt(e), 3)}>
                </Textfield>
            </FieldLabel>
            <div className="adobe-skycity-button-right">
                <Button variant="cta" onClick={e => run(e)} disabled={isRunDisabled()}>{__('btn_run')}</Button>
            </div>
        </div>
    } catch (e) {
        console.log(e)
        error(`${__('error_msg_title')}: ${e}`, {
            timeout: 0
        })
    }
}
